// Lib
import React, { useCallback } from 'react';
import Immutable from 'immutable';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import ToolbarTool from '../../ToolbarTool';
import Icon from '../../../../../components/icons/Icon';
import { useDispatch } from 'react-redux';
import { moveElementsToTrash } from '../../../../../element/actions/elementShortcutActions';
import { ToolTypeSettings, ToolbarSettings } from '../../../toolbarTypes';
import { removeSelectedLabel } from '../../../../../element/labels/elementLabelActions';
import { useTiptapEditorByIdCallback } from '../../../../../components/tiptapEditor/store/tiptapEditorStoreHooks';

type RemoveElementToolProps = {
    currentBoardId: string;
    selectedElements: Immutable.List<ImMNElement>;
    toolSettings?: ToolbarSettings;
};

const RemoveElementTool: React.FC<RemoveElementToolProps> = (props) => {
    const { selectedElements, currentBoardId, toolSettings } = props;
    const dispatch = useDispatch();
    const getTiptapEditor = useTiptapEditorByIdCallback();

    const dispatchMoveElementsToTrash = useCallback(
        () => dispatch(moveElementsToTrash({ elements: selectedElements, currentBoardId })),
        [selectedElements, currentBoardId],
    );

    const dispatchRemoveLabelFromElement = useCallback(
        () => dispatch(removeSelectedLabel(getTiptapEditor)),
        [dispatch, getTiptapEditor],
    );

    const onClick = useCallback(() => {
        const isLabel = (toolSettings as ToolTypeSettings)?.isLabel;
        return isLabel ? dispatchRemoveLabelFromElement() : dispatchMoveElementsToTrash();
    }, [toolSettings, dispatchRemoveLabelFromElement, dispatchMoveElementsToTrash]);

    return (
        <div className="RemoveElementTool">
            <ToolbarTool {...props} onClick={onClick}>
                <Icon name="toolbar-move-to-trash" />
            </ToolbarTool>
        </div>
    );
};

export default RemoveElementTool;
